import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { CancelIcon } from "../core";

function DetailsModal({ showModal, onClose, details }) {
  const [tags, setTags] = useState([]);

  const addTags = (serviceOffering, countries) => {
    const newTag = [];
    const services = Array.isArray(serviceOffering)
      ? serviceOffering
      : [serviceOffering];
    const country = Array.isArray(countries) ? countries : [countries];

    services.forEach((service, index) => {
      newTag.push(`${service}-${country[index] || country[0]}`);
    });
    setTags(newTag);
  };

  useEffect(() => {
    if (details) {
      addTags(details?.servicesProvided, details?.serviceCountries);
    }
  }, [details]);

  return (
    <>
      {showModal && (
        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity">
              <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <button
                type="button"
                onClick={() => onClose()}
                className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500 rounded"
                aria-label="Close modal"
              >
                <CancelIcon size={6} color="teal-700" />
              </button>
              <div className="bg-white px-3 pt-4 pb-3 sm:p-4 sm:pb-3">
                <div>
                  <div className="my-2">
                    <div className="bg-white overflow-hidden shadow rounded-lg border">
                      <div className="px-4 py-5 sm:px-6">
                        <h3 className="text-lg leading-6 font-medium text-gray-900">
                          Service Provider Details
                        </h3>
                      </div>
                      <div className="border-t border-gray-200 px-4 py-5 sm:p-0 overflow-y-auto max-h-[500px]">
                        <dl className="sm:divide-y sm:divide-gray-200">
                          <div className="py-1 grid grid-cols-8 gap-2 px-6">
                            <dt className="text-sm font-medium text-gray-500 col-span-4">
                              Service Provider Name
                            </dt>
                            <dd className="m-px text-sm text-gray-900 mt-0 col-span-4">
                              {details?.serviceProviderName}
                            </dd>
                          </div>
                          <div className="py-1 grid grid-cols-8 gap-2 px-6">
                            <dt className="text-sm font-medium text-gray-500 col-span-4">
                              Service Provider URL
                            </dt>
                            <dd className="m-px text-sm text-gray-900 mt-0 col-span-4">
                              {details?.serviceProviderURL}
                            </dd>
                          </div>
                          <div className="py-1 grid grid-cols-8 gap-2 px-6">
                            <dt className="text-sm font-medium text-gray-500 col-span-4">
                              Request Id
                            </dt>
                            <dd className="m-px text-sm text-gray-900 mt-0 col-span-4">
                              {details?.requestId}
                            </dd>
                          </div>
                          <div className="py-1 grid grid-cols-8 gap-2 px-6">
                            <dt className="text-sm font-medium text-gray-500 col-span-4">
                              Address
                            </dt>
                            <dd className="m-px text-sm text-gray-900 mt-0 col-span-4">
                              {details?.address}
                            </dd>
                          </div>
                          <div className="py-1 grid grid-cols-8 gap-2 px-6">
                            <dt className="text-sm font-medium text-gray-500 col-span-4">
                              Country
                            </dt>
                            <dd className="m-px text-sm text-gray-900 mt-0 col-span-4">
                              {details?.country}
                            </dd>
                          </div>
                          <div className="py-1 grid grid-cols-8 gap-2 px-6">
                            <dt className="text-sm font-medium text-gray-500 col-span-4">
                              Services Provided by Countries
                            </dt>
                            <dd className="m-px text-sm text-gray-900 mt-0 col-span-4">
                              {tags.length > 0 && (
                                <div className="inline-block gap-2 mt-1">
                                  {tags.map((tag, index) => (
                                    <span
                                      key={index + 1}
                                      className="inline-flex items-center rounded-xl bg-gray-200 px-1 mx-1 my-1 text-md font-medium ring-1 ring-inset ring-gray-500/10 h-fit space-x-2"
                                    >
                                      <span>{tag}</span>
                                    </span>
                                  ))}
                                </div>
                              )}
                            </dd>
                          </div>

                          <div className="py-1 grid grid-cols-8 gap-2 px-6">
                            <dt className="text-sm font-medium text-gray-500 col-span-4">
                              Primary Name
                            </dt>
                            <dd className="m-px text-sm text-gray-900 mt-0 col-span-4">
                              {details?.primaryName}
                            </dd>
                          </div>
                          <div className="py-1 grid grid-cols-8 gap-2 px-6">
                            <dt className="text-sm font-medium text-gray-500 col-span-4">
                              Primary Email
                            </dt>
                            <dd className="m-px text-sm text-gray-900 mt-0 col-span-4">
                              {details?.primaryEmail}
                            </dd>
                          </div>
                          <div className="py-1 grid grid-cols-8 gap-2 px-6">
                            <dt className="text-sm font-medium text-gray-500 col-span-4">
                              Primary Phone Number
                            </dt>
                            <dd className="m-px text-sm text-gray-900 mt-0 col-span-4">
                              {details?.primaryContact}
                            </dd>
                          </div>
                          <div className="py-1 grid grid-cols-8 gap-2 px-6">
                            <dt className="text-sm font-medium text-gray-500 col-span-4">
                              Primary Title
                            </dt>
                            <dd className="m-px text-sm text-gray-900 mt-0 col-span-4">
                              {details?.primaryTitle}
                            </dd>
                          </div>
                          <div className="py-1 grid grid-cols-8 gap-2 px-6">
                            <dt className="text-sm font-medium text-gray-500 col-span-4">
                              Secondary Name
                            </dt>
                            <dd className="m-px text-sm text-gray-900 mt-0 col-span-4">
                              {details?.secondaryName}
                            </dd>
                          </div>
                          <div className="py-1 grid grid-cols-8 gap-2 px-6">
                            <dt className="text-sm font-medium text-gray-500 col-span-4">
                              Secondary Email
                            </dt>
                            <dd className="m-px text-sm text-gray-900 mt-0 col-span-4">
                              {details?.secondaryEmail}
                            </dd>
                          </div>
                          <div className="py-1 grid grid-cols-8 gap-2 px-6">
                            <dt className="text-sm font-medium text-gray-500 col-span-4">
                              Secondary Phone Number
                            </dt>
                            <dd className="m-px text-sm text-gray-900 mt-0 col-span-4">
                              {details?.secondaryContact}
                            </dd>
                          </div>
                          <div className="py-1 grid grid-cols-8 gap-2 px-6">
                            <dt className="text-sm font-medium text-gray-500 col-span-4">
                              Secondary Title
                            </dt>
                            <dd className="m-px text-sm text-gray-900 mt-0 col-span-4">
                              {details?.secondaryTitle}
                            </dd>
                          </div>
                        </dl>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

DetailsModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  details: PropTypes.object,
};

export default DetailsModal;
